import { appendStyle, isSafari } from '@1inch-community/core/lit-utils';
export function slideAnimation() {
    const initStyle = {
        position: 'absolute',
        top: '0',
        left: '0',
        bottom: '0',
        right: '0',
        zIndex: '9',
        backfaceVisibility: 'hidden',
        height: isSafari() ? '100%' : '',
    };
    const resetStyle = {
        position: '',
        top: '',
        left: '',
        bottom: '',
        right: '',
        zIndex: '',
        transform: '',
        filter: '',
        backfaceVisibility: '',
        willChange: '',
        height: '',
    };
    const DEFAULT_DURATION = 800;
    const animationConfig = {
        duration: DEFAULT_DURATION,
        easing: 'cubic-bezier(.2, .8, .2, 1)',
    };
    return {
        preparation: async (upLayer, downLayer, isBack) => {
            appendStyle(upLayer, {
                ...initStyle,
                zIndex: '9',
                transform: isBack ? 'translate3d(0, 0, 0)' : 'translate3d(100%, 0, 0)',
            });
            appendStyle(downLayer, {
                ...initStyle,
                zIndex: '8',
                willChange: 'transform, filter',
                transform: isBack ? 'translate3d(-50%, 0, 0) scale(.9)' : 'translate3d(0, 0, 0) scale(1)',
                filter: isBack ? 'blur(3px)' : 'blur(0)',
            });
        },
        transition: async (upLayer, downLayer, isBack, immediate) => {
            animationConfig.duration = immediate ? 1 : DEFAULT_DURATION;
            await Promise.all([
                upLayer.animate([
                    { transform: isBack ? 'translate3d(0, 0, 0)' : 'translate3d(105%, 0, 0)' },
                    { transform: isBack ? 'translate3d(105%, 0, 0)' : 'translate3d(0, 0, 0)' },
                ], animationConfig),
                downLayer.animate([
                    {
                        transform: isBack
                            ? 'translate3d(-50%, 0, 0) scale(.9)'
                            : 'translate3d(0, 0, 0) scale(1)',
                        filter: isBack ? 'blur(3px)' : 'blur(0)',
                    },
                    {
                        transform: isBack
                            ? 'translate3d(0, 0, 0) scale(1)'
                            : 'translate3d(-50%, 0, 0) scale(.9)',
                        filter: isBack ? 'blur(0)' : 'blur(3px)',
                    },
                ], animationConfig).finished,
            ]);
            appendStyle(upLayer, { ...resetStyle });
            appendStyle(downLayer, { ...resetStyle });
        },
    };
}
//# sourceMappingURL=slide.animation.js.map